import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { RxCross1 } from "react-icons/rx";
import AsyncSelect from 'react-select/async';

const DirectItems = ({ onRequisitionData, itemData, formData, currencyPrecision }) => {
    const rows = useSelector(state => state.rows.rows);
    const dispatch = useDispatch();
    const [itemOptions, setItemOptions] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const apiService = new ApiService();
    const initialMount = useRef(true);
    const rowsUpdated = useRef(false);

    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const getItems = async () => {
            try {
                if (initialMount.current && itemData?.prDetails && itemData.prDetails.length > 0) {
                    const formattedRows = itemData?.prDetails?.map(detail => (
                        {
                            requisitionNo: detail.requisitionNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: 0,
                            conValue: detail.baseQty,
                            baseAmount: detail.unitPrice,
                            specification: detail.specification,
                            amount: detail.amount,
                            stock: detail.stock,
                            bol: ''
                        }));
                    dispatch(setRows(formattedRows));
                    onRequisitionData(formattedRows);
                } else if (initialMount.current && itemData?.issueDetails && itemData.issueDetails.length > 0) {
                    const formattedRowsPromises = itemData?.issueDetails.map(async (detail, index) => {
                        const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${itemData?.warehouse}&itemNo=${detail?.itemCode}`);
                        let item = selecteditmstock?.data.result?.[0]
                        return {
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail?.qty,
                            uom: detail?.uom,
                            baseQty: detail?.qty * 1,
                            conValue: detail?.convToInvUOM,
                            unitPrice: item?.avgPrice,
                            specification: detail.specification,
                            amount: item?.avgPrice * detail?.qty,
                            stock: item?.stock,
                            bol: '',
                            cgsAcc: item.acCode,
                            cgsAccName: item.acName,
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsPromises);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        onRequisitionData(formattedRows);
                    }
                    if (formData && formData && rows[0].itemNo && !rowsUpdated) {
                        updateRowsWithNewStock();
                        rowsUpdated.current = true;
                    }
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };
        if (itemData) {
            getItems();
        }

    }, [itemData, dispatch, onRequisitionData, rows]);
    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            itemRows.forEach((row, index) => {
                dispatch(updateRow(index, row));
            });
        }
    }, [itemRows, dispatch]);
    useEffect(() => {
        if (formData && rows[0].itemNo) {
            updateRowsWithNewStock()
        }

    }, [formData]);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);
    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoader(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoader(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoader(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoader(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoader(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoader(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage(prevPage => prevPage + 1);
        await fetchItemNo("", page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc("", desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        try {

            const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
            if (isDuplicate) {
                toast.error('Please choose a different item.');
                return;
            }
            if (!formData) {
                toast.warning("Select From Location")
                return;
            }
            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                if (quantity < 0) {
                    toast.warning('Quantity cannot be less than 0.');
                    return;
                }
            }
            const updatedRows = [...rows];
            const updatedRow = { ...updatedRows[index], [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };
            if (fieldName === 'itemNo' || fieldName === 'itemDescription') {
                const queryParam = fieldName === 'itemNo' ? `itemNo=${value}` : `ItemDescription=${value}`;
                const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${formData}&${queryParam}`);
                let selectedItem = selecteditmstock?.data?.result?.[0]
                const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${selectedItem?.itemNo}`);
                let glAccount = getGLAccounts?.data?.result[0]
                if (selectedItem) {
                    updatedRow.itemDescription = selectedItem?.itemDescription;
                    updatedRow.requisitionNo = selectedItem?.itemDescription;
                    updatedRow.uom = selectedItem?.unitMeasurement;
                    updatedRow.itemNo = selectedItem?.itemNo;
                    updatedRow.specification = selectedItem?.specification;
                    updatedRow.baseQty = 0;
                    updatedRow.unitPrice = parseFloat(selecteditmstock?.data?.result?.[0]?.avgPrice?.toFixed(currencyPrecision || 0)) || 0;
                    updatedRow.stock = selecteditmstock?.data?.result?.[0]?.stock || 0;
                    updatedRow.cgsAcc = glAccount?.cgsAccountCode;
                    updatedRow.cgsAccName = glAccount?.cgsAccountName;
                    updatedRow.amount = 0;
                }
            }
            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                const stock = updatedRow?.stock;
                const unitPrice = parseFloat(updatedRow?.unitPrice);
                if (quantity > stock) {
                    toast.warning('Enter a quantity less than or equal to the Stock.');
                    return
                } else {
                    const baseQty = 1;
                    updatedRow.baseQty = (!isNaN(quantity) && quantity !== 0) ? (quantity * baseQty).toFixed(currencyPrecision || 0) : 0;
                    updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(currencyPrecision || 0) : 0;
                }
            }
            if (fieldName === 'qty' || fieldName === 'baseAmount') {
                const quantity = parseFloat(updatedRow.qty);
                const stock = updatedRow.stock;
                if (quantity > stock) {
                    toast.warning('Enter a quantity less than or equal to the Stock.');
                    return
                }
                const unitPrice = parseFloat(updatedRow.unitPrice);
                updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(currencyPrecision || 0) : 0;
            }
            updatedRows[index] = updatedRow;
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            itemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            convRate: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
            recordId: '',
            specification: '',
            supplierId: '',
            cgsAcc: "",
            cgsAccName: "",
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows)); // Ensure Redux state is updated here
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));

    };
    const updateRowsWithNewStock = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.itemNo}`;

                const response = await apiService.getApiParamater(
                    'GET_ITEM_STORE',
                    `?Warehouse=${formData || itemData.warehouse}&${queryParam}`
                );
                if (response?.data?.statusCode === 200) {
                    const itemData = response.data.result[0];
                    updatedRows[index].stock = itemData.stock || 0;
                    updatedRows[index].itemDescription = itemData.itemDescription;
                    updatedRows[index].baseAmount = itemData.avgPrice || 0;
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            dispatch(setRows([...updatedRows]));
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th></th>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Inventory UOM</th>
                        <th>Qty</th>
                        <th>Inventory Qty</th>
                        <th>Stock</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                        <th>CGS Acc </th>
                        <th>CGS Acc Name </th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(itemRows) && rows?.map((row, index) => (
                        <tr key={index}>
                            {itemData?.eye ?
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", cursor: "not-allowed" }}>
                                    <div className='center'>
                                        <RxCross1 size={25} disabled />
                                    </div>
                                </td> :
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                    <div onClick={() => handleRemoveRow(index)} className='center'>
                                        <RxCross1 size={25} />
                                    </div>
                                </td>
                            }
                            <td className='m-0 p-0'><input className='p-2' type="text" style={{ width: "80px" }} value={row.srno} disabled /></td>
                            <td className='m-0 p-0'>
                                {itemData?.eye ?
                                    <input className='p-2' type='text' disabled value={row?.itemNo} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemNo, label: row.itemNo }}
                                        options={itemOptions}
                                        loadOptions={loadOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemNo', selectedOption.label)}
                                        className="w-100 p-0"
                                        defaultOptions={itemOptions}
                                        onMenuScrollToBottom={loadMoreOptions}
                                    />
                                }
                            </td>
                            <td className='m-0 p-0'>
                                {itemData?.eye ?
                                    <input className='p-2' disabled value={row.itemDescription} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemDescription, label: row.itemDescription }}
                                        options={descriptionOptions}
                                        loadOptions={loadDescOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                        className="w-100 p-0"
                                        defaultOptions={descriptionOptions}
                                        onMenuScrollToBottom={loadMoreDescOptions}
                                    />
                                }
                            </td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' style={{ width: "130px" }}
                                    type="text" value={row.specification} onChange={e => handleInputChange(index, 'specification', e.target.value)} /></td>
                            }
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.uom} style={{ width: "130px" }} /></td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "100px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' type="number" value={row.qty} onKeyDown={preventNegativeSign}
                                    onWheel={(e) => e.target.blur()}
                                    style={{ width: "100px" }}
                                    onChange={e => handleInputChange(index, 'qty', e.target.value)} /></td>
                            }
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "130px" }} value={row.baseQty} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.stock).toFixed(2)} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.unitPrice).toFixed(currencyPrecision || 0)} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount).toFixed(currencyPrecision || 0)} style={{ width: "120px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.cgsAcc} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.cgsAccName} style={{ width: "130px" }} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {itemData?.eye ? "" :
                <div className='row mt-5'>
                    <div className='col-2'>
                        <button className='mainbtn ' onClick={addNewRow}>
                            Add Item
                        </button>
                    </div>
                </div>
            }
        </div>
    );
};

export default DirectItems;